import { render, staticRenderFns } from "./ProyectoForm.vue?vue&type=template&id=de99157c&"
import script from "./ProyectoForm.vue?vue&type=script&lang=js&"
export * from "./ProyectoForm.vue?vue&type=script&lang=js&"
import style0 from "./ProyectoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports